import {
  Box,
  Button,
  Grid,
  GridItem,
  HStack,
  SimpleGrid,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { BiArrowBack, BiMap } from "react-icons/bi";
import ProductCard from "../components/card/ProductCard";
import DetailCompany from "../components/modals/DetailCompany";
import FetchData from "../services/FetchData";
import HubungiPenjual from "../components/modals/HubungiPenjual";

//image
import ImageCompany from "../assets/default/perusahaan.png";

export default function ProductSeller() {
  const { id } = useParams();
  const [mobile] = useMediaQuery("(max-width: 770px)");
  let imgSize = mobile ? "100px" : "200px";

  const { data } = FetchData({ url: "/sellers/" + id + "/items" });
  const { data: data1 } = FetchData({ url: "/sellers/" + id });

  const [open, setOpen] = useState(false);
  const [openContact, setOpenContact] = useState(false);

  const handleCloseDetail = () => {
    setOpen(false);
  };
  const handleCloseContact = () => {
    setOpenContact(false);
  };

  console.log(data);
  return (
    <Box px={mobile ? "3" : "20"} py="5">
      <Link to="/">
        <Box display="flex" alignItems="center">
          <BiArrowBack />
          <Text fontWeight="400" pl="2">
            Kembali Ke Beranda
          </Text>
        </Box>
      </Link>
      <Grid
        templateColumns={mobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)"}
        borderRadius="10px"
        border="1px solid #E0E0E0"
        width="full"
        p="5"
        my="3"
      >
        <GridItem display="flex" colSpan={2}>
          <img
            src={ImageCompany}
            alt="Logo"
            style={{
              borderRadius: "100px",
              width: imgSize,
              height: imgSize,
            }}
          />
          <Box
            display="flex"
            justifyContent="center"
            flexDirection="column"
            px="4"
            width="full"
          >
            <Text fontWeight="500" fontSize={mobile ? "15" : "28"}>
              {data1?.company}
            </Text>
            <Text
              fontWeight="400"
              fontSize={mobile ? "15" : "28"}
              color="GrayText"
            >
              <Box display="flex" alignItems="center">
                <BiMap /> {data1?.address}
              </Box>
            </Text>
          </Box>
        </GridItem>
        <GridItem
          display="flex"
          alignItems="center"
          justifyContent="end"
          pt={mobile && "2"}
        >
          <HStack spacing="10px">
            <Button
              variant="solid"
              width="full"
              colorScheme="blue"
              size={mobile ? "lg" : "md"}
              onClick={() => setOpenContact(true)}
            >
              Hubungi Penjual
            </Button>
            <Button
              variant="outline"
              width="full"
              colorScheme="gray"
              size={mobile ? "lg" : "md"}
              onClick={() => setOpen(true)}
            >
              Detail Perusahaan
            </Button>
          </HStack>
        </GridItem>
      </Grid>
      <Text py="5" fontWeight="400" fontSize="20">
        Semua Produk
      </Text>
      <SimpleGrid columns={[2, null, 3, null, 5]} spacing={1}>
        {data?.map((item, key) => (
          <ProductCard
            key={key}
            image={item.product_img}
            name={item.product_name}
            price={item.unit_price}
            sellerId={item.seller_id}
            itemId={item.item_id}
          />
        ))}
      </SimpleGrid>
      <DetailCompany
        isOpen={open}
        onClose={handleCloseDetail}
        name={data1?.company}
        description={data1?.description}
      />
      <HubungiPenjual
        isOpen={openContact}
        onClose={handleCloseContact}
        data={data1}
      />
    </Box>
  );
}
